import { Text } from "@meditect/medibase-components";

import { useUserCountry } from "@/hooks/useUserCountry";
import { formatCurrency } from "@/utils/formatCurrency";

import { ErrorMessageComponent } from "../../domain/ErrorMessageComponent";

interface SalesCannotCloseSaleWithCreditLimitExceededErrorExtra {
  buyerName: string;
  creditLimit: number;
  currentCreditAfterSale: number;
  currentCreditBeforeSale: number;
}

export const SalesCannotCloseSaleWithCreditLimitExceededError: ErrorMessageComponent<
  SalesCannotCloseSaleWithCreditLimitExceededErrorExtra
> = ({ extra }) => {
  const country = useUserCountry();
  const exceeding = extra.currentCreditAfterSale - extra.creditLimit;

  return (
    <>
      <Text mb={4}>{extra.buyerName} a atteint la limite de crédit autorisé.</Text>
      <Text mb={4}>
        La valeur courante de son crédit est de {formatCurrency(extra.currentCreditBeforeSale, country)}, en clôturant
        cette vente son crédit dépasserait de {formatCurrency(exceeding, country)} la limite de crédit fixée à{" "}
        {formatCurrency(extra.creditLimit, country)}.
      </Text>
      <Text mb={4}>Pour clôturer cette vente, veuillez soit :</Text>
      <Text mb={2}>• diminuer le montant du paiement à crédit de cette vente</Text>
      <Text mb={2}>• encaisser les factures de crédits de ce patient</Text>
      <Text mb={4}>• augmenter sa limite de crédit</Text>
    </>
  );
};
